// extracted by mini-css-extract-plugin
export default {"container":"_2ktIcDeZ6Gx_cIJPwUAP-H","errorHeader":"_3nmJ-sZ0d3MGRnYUg5TtNL"};